"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = exports.validResizes = void 0;
var react_1 = __importStar(require("react"));
var useUniqueID_1 = require("../utils/useUniqueID");
var useDescribers_1 = require("../utils/useDescribers");
var helperFunctions_1 = require("../utils/helperFunctions");
var TextInputBase_1 = require("../TextInputBase/TextInputBase");
var css_1 = require("@emotion/css");
exports.validResizes = ['none', 'vertical'];
var textboxStyles = function (resize) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  resize: ", ";\n"], ["\n  resize: ", ";\n"])), resize); };
exports.TextArea = react_1.default.forwardRef(function (_a, ref) {
    var ariaLabel = _a["aria-label"], className = _a.className, ContainerProps = _a.ContainerProps, containerRef = _a.containerRef, endAdornment = _a.endAdornment, error = _a.error, guidance = _a.guidance, help = _a.help, id = _a.id, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, isRequired = _a.isRequired, label = _a.label, onChange = _a.onChange, placeholder = _a.placeholder, startAdornment = _a.startAdornment, style = _a.style, testId = _a.testId, units = _a.units, value = _a.value, _c = _a.resize, resize = _c === void 0 ? 'none' : _c, _d = _a.rows, rows = _d === void 0 ? 2 : _d, rest = __rest(_a, ['aria-label', "className", "ContainerProps", "containerRef", "endAdornment", "error", "guidance", "help", "id", "isDisabled", "isRequired", "label", "onChange", "placeholder", "startAdornment", "style", "testId", "units", "value", "resize", "rows"]);
    if (!exports.validResizes.includes(resize)) {
        throw new Error("Invalid resize, valid resizes are [".concat(exports.validResizes, "] and you passed in [").concat(resize, "]."));
    }
    if (rows < 1) {
        throw new Error("Invalid rows, valid rows are greater than 1 and you passed in [".concat(rows, "]."));
    }
    var uniqueId = (0, useUniqueID_1.useUniqueId)(id);
    var describers = (0, useDescribers_1.useDescribers)({ help: help, uniqueId: uniqueId, guidance: guidance });
    var onTextChange = (0, react_1.useCallback)(function (event) {
        if (!isDisabled) {
            onChange(event, event.target.value);
        }
    }, [isDisabled, onChange]);
    return (react_1.default.createElement(TextInputBase_1.TextInputBase, { componentName: "TextArea", uniqueId: uniqueId, "aria-label": ariaLabel, className: className, ContainerProps: ContainerProps, containerRef: containerRef, endAdornment: endAdornment, error: error, guidance: guidance, help: help, isDisabled: isDisabled, label: label, placeholder: placeholder, startAdornment: startAdornment, style: style, testId: testId, units: units },
        react_1.default.createElement("textarea", __assign({ required: isRequired, id: uniqueId, disabled: isDisabled, ref: ref, value: value || '', "data-testid": testId, onChange: onTextChange, 
            // by not having a placeholder to show we will always be in a state where placeholdershown is false putting the label in the top section
            placeholder: (0, helperFunctions_1.getPlaceholder)(placeholder, !!startAdornment), "aria-describedby": describers, "aria-errormessage": "".concat(uniqueId, "-error"), "aria-invalid": !!error, "aria-label": ariaLabel, className: textboxStyles(resize), rows: rows }, rest))));
});
exports.TextArea.displayName = 'TextArea';
var templateObject_1;
